import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'
import BentoGrid from '@/Components/custom/bento-grid'
import { usePage } from '@inertiajs/react'
import EnhancedBentoGrid from '@/Components/custom/enhanced-bento-grid'

export default function Vas() {
  const { services } = usePage().props
  const blocks = useBlockRenderer('plans') as Block[]

  return (
    <>
      <BlockRenderer blocks={blocks} />
      <BentoGrid services={services} />
      {/* <EnhancedBentoGrid /> */}
    </>
  )
}
